module.exports = "/_next/static/images/icon__chips-size-small-color-673f18f31b4d7aeabc3a246d54a8ca17.png";